import { Display } from "../../../../Models/Display";

export const responsiveDetails = (display?: Display) => {
  return {
    cells: {
      // --- Header Grid ---
      costShipment: { gridArea: "costShipment" },
      weightAndVolume: { gridArea: "weightAndVolume" },
      valueShipmentCost: { gridArea: "valueShipmentCost" },

      // --- Main Grid ---
      pickupAndDelivery: { gridArea: "pickupAndDelivery" },
      generalInformation: { gridArea: "generalInformation" },
      labelAndDocuments: { gridArea: "labelAndDocuments" },
      parcels: { gridArea: "parcels" },
      customData: { gridArea: "customData" },

      // --- CardInformationCost Grid ---
      carrier: { gridArea: "carrier" },
      nameCarrierAndShipmentType: { gridArea: "nameCarrierAndShipmentType" },

      // --- GeneralInformation Grid ---
      internalReference: { gridArea: "internalReference" },
      externalReference: { gridArea: "externalReference" },
      creationUser: { gridArea: "creationUser" },
      creationDate: { gridArea: "creationDate" },
      note: { gridArea: "note" },
      content: { gridArea: "content" },
    },

    // GRID Header
    header: {
      display: "grid",
      gridArea: "header",
      gridTemplateColumns: display?.xs
        ? "1fr 1fr"
        : display?.sm || display?.md
          ? "1fr 1fr 1fr"
          : "50% 1fr 1fr 1fr",
      gridTemplateAreas: display?.xs
        ? `
      "service service"
      "costShipment valueShipmentCost"
      "weightAndVolume weightAndVolume"
    `
        : display?.sm || display?.md
          ? `
        " service service service "
        " costShipment weightAndVolume valueShipmentCost "
      `
          : `
        " service costShipment weightAndVolume valueShipmentCost "
      `,
    },

    // GRID Main
    main: {
      display: "grid",
      gridTemplateColumns: display?.xs || display?.sm ? "1fr" : "50% 1fr",
      gridTemplateRows: "0fr 0fr 1fr auto ",
      gridTemplateAreas:
        display?.xs || display?.sm
          ? `
      " header "
      " pickupAndDelivery "
      " generalInformation "
      " labelAndDocuments "
      " parcels "
      " customData "
    `
          : `
      " header header"  
      " pickupAndDelivery labelAndDocuments"
      " generalInformation labelAndDocuments"
      " parcels parcels"
      " customData customData"
    `,
    },

    // GRID CardInformationCost
    cardInformationCost: {
      display: "grid",
      gridArea: "service",
      gridTemplateColumns: "0.25fr 1fr",
      gridTemplateAreas: `
      " carrier nameCarrierAndShipmentType "
      `,
    },

    // GRID GeneralInformation
    generalInformation: {
      display: "grid",
      gridTemplateColumns: display?.xs && display?.sm ? "1fr" : "1fr 1fr",
      gridTemplateAreas:
        display?.xs && display?.sm
          ? `
      " internalReference "
      " externalReference "
      " creationUser "
      " creationDate "
      " note "
      " content "
    `
          : `
        " internalReference externalReference "
        " creationUser creationDate "
        " note note "
        " content content "
      `,
    },
  };
};
